import {React, observer, useEffect} from '@api'
import * as css from './AdminPage.css'
// import JsonView from 'react-json-view'
import { useStores } from '@modules'

export const VipBoardConfigAdminPage = observer(() => {
  const {workspaces} = useStores()
  useEffect(() => {
    workspaces.current = 'VIP Config'
  }, [])
  return <div className={css.root}>
    <div>
      Board Config Page

      {/*<JsonView src={workspaces.deploymentConfig} />*/}
    </div>
  </div>
})



// WEBPACK FOOTER //
// ./src/modules/admin/pages/VipBoardConfigAdminPage.tsx